import { useRef } from "react";
import { TaskTypeDetailHeaderComponent } from "../../components/TaskTypeComponents/TaskTypeDetailHeaderComponent";
import { TaskTemplateGrid } from "../../components/TaskTypeComponents/TaskTemplateGrid";
import { Button, Tab } from "@etframework/ui.components";
import useModalEvent from "../../hooks/useModalEvent";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useTaskType } from "../../data/queries/taskTypeQueries";
import { DataFieldsSection } from "./DataFieldsSection";
import { PreferencesContainer } from "../../components/TaskTypeComponents/PreferencesContainer";
import Enums from "../../types/enums";

export const TaskTypeDetails = () => {
  const { t } = useTranslation(["TaskTypes", "Preferences"]);

  const taskTemplateGridRef = useRef(null);

  const { ModalEvents, toggleModal } = useModalEvent();
  const { taskTypeId } = useParams();
  const { data: taskTypeData } = useTaskType(taskTypeId);

  return (
    <div className="et-task-types">
      <div className="row px-3 pt-4 sticky-top" id="et-task-type-sticky-header">
        <div className="col-6">
          <TaskTypeDetailHeaderComponent taskTypeData={taskTypeData} />
        </div>

        {taskTypeData?.Type !== Enums.TaskType.TaxReturn && (
          <div className="col-6 d-flex justify-content-end">
            <Button
              text={t("DeleteTaskType")}
              className="btn-tertiary w-auto"
              onClick={() => {
                toggleModal(ModalEvents.DeleteTaskTypeConfirmationModal);
              }}
              iconCss="fa-regular fa-trash-can delete-icon"
            />
          </div>
        )}
      </div>
      <div className="module-layout-content">
        <Tab
          heightAdjustMode="Fill"
          tabNames={[
            t("TaskTemplates"),
            t("CustomFields"),
            t("Preferences:Preferences"),
          ]}
          tabComponents={[
            () => (
              <div className="p-4">
                <TaskTemplateGrid
                  id="dd_settings_board-settings_task-template-grid"
                  taskTypeId={taskTypeId}
                  ref={taskTemplateGridRef}
                />
              </div>
            ),
            () => (
              <div className="p-4">
                <DataFieldsSection taskType={taskTypeData} />
              </div>
            ),
            () => (
              <div className="p-4">
                <PreferencesContainer taskType={taskTypeData} />
              </div>
            ),
          ]}
        />
      </div>
    </div>
  );
};
